import { Avatar, Tooltip } from '@mui/material';
import Chip, { ChipProps } from '@mui/material/Chip';
import * as React from 'react';
import { UserInfo } from '../../../sic-lib/types/UserConfig';
import { getUserAvatarData } from '../../../sic-lib/utils/userHelpers';

export default React.memo(function UserChip({ userName, users, ...props }: Props) {
    const avatarData = React.useMemo(
        () => getUserAvatarData(undefined, users, userName),
        [users, userName],
    );

    if (!avatarData) return null;

    return (
        <Tooltip title={avatarData?.tooltip}>
            <Chip
                sx={{
                    '& .MuiChip-avatar': { color: 'white' },
                }}
                avatar={
                    <Avatar sx={{ backgroundColor: avatarData.background }}>
                        {avatarData.initials}
                    </Avatar>
                }
                label={userName}
                variant="outlined"
                {...props}
            />
        </Tooltip>
    );
});

type Props = ChipProps & {
    userName: string | null | undefined;
    users: UserInfo[] | undefined;
};
